'use client';

import { c as _c } from "react/compiler-runtime";
import type { Hash } from 'viem';
import { type ChainId, ChainUtils } from '@morpho-org/blue-sdk';
import { abbreviateAddress } from '@repo/utils';
import { memo } from 'react';
import { ButtonLink } from '@/components/common/ButtonLink';
export interface TransactionHashCellProps {
  hash: Hash;
  chainId: ChainId;
}
const TransactionHashCell = t0 => {
  const $ = _c(10);
  const {
    hash,
    chainId
  } = t0;
  let t1;
  if ($[0] !== chainId || $[1] !== hash) {
    t1 = ChainUtils.getExplorerTransactionUrl(chainId, hash);
    $[0] = chainId;
    $[1] = hash;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== hash) {
    t2 = abbreviateAddress(hash);
    $[3] = hash;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = {
      variant: "ghost",
      size: "default",
      label: t2
    };
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <ButtonLink href={t1} mode="external" buttonProps={t3} />;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default memo(TransactionHashCell);